import './TextArea.scss';
import { getInputWrapperClassList } from '../../utils/input/input';
import Text from '../Text/Text';

type TextAreaTypes = {
  inputId: string;
  label?: string;
  value?: string;
  onChange: () => void;
  placeholder?: string;
  inactive?: boolean;
  readOnly?: boolean;
  error?: string;
  notes?: boolean;
  required?: boolean;
  disabled?: boolean;
};

const TextArea = ({
  inputId,
  label,
  value = '',
  onChange,
  placeholder = '',
  inactive = false,
  readOnly = false,
  error = '',
  notes = false,
  required = false,
  disabled = false,
}: TextAreaTypes) => {
  return (
    <div
      className={`input-text-area-container${error ? ' error' : ''} ${notes ? ' notes' : ''}`}
      data-testid="textarea-container"
    >
      {label && (
        <label htmlFor={inputId} className="body-small">
          <Text type="body" size="small">
            {`${label} ${required ? '*' : ''}`}
          </Text>
        </label>
      )}
      <div
        className={getInputWrapperClassList(
          'input-text-area-wrapper body',
          readOnly,
          inactive,
          error,
          false,
          false,
          disabled,
        )}
      >
        <textarea
          data-testid={inputId}
          id={inputId}
          name={inputId}
          placeholder={`${placeholder}${required ? ' (required)' : ''}`}
          readOnly={readOnly || inactive ? true : false}
          value={value}
          onChange={onChange}
          wrap="soft"
          disabled={disabled}
        />
      </div>
      {error && (
        <Text type="body" size="small" className="error-message">
          {error}
        </Text>
      )}
    </div>
  );
};
export default TextArea;
